import {
    TextField,
    FormControl,
    Typography,
    FormControlLabel,
    Switch,
    MenuItem,
    InputLabel,
    Select,
    Grid,
    Divider
} from "@mui/material";
import React from "react";
import InfoTooltip from "../../utils/UI/InfoTooltip";

function CheckoutTab({
    styles,
    bookingStates,
    bookingStatesChangeHandler,
    offersPackagesOnly
}) {
    return (
        <>
            <Grid item variant="subHeading">
                <Typography variant="largerSubHeading">Checkout</Typography>
            </Grid>
            <Grid item variant={"subHeading-divider"}>
                <Divider />
            </Grid>
            <Grid container item xs={12} sm={12}>
                <FormControl sx={{ width: "50%", paddingRight: "9px" }}>
                    <InputLabel>Client checkout behaviour</InputLabel>
                    <Select
                        id="customer-accounts-field"
                        label="Client checkout behaviour"
                        variant="outlined"
                        disableUnderline
                        name={"checkoutOption"}
                        value={bookingStates.checkoutOption}
                        onChange={bookingStatesChangeHandler}
                        InputProps={{ shrink: false }}
                    >
                        <MenuItem
                            key={"MUST_CREATE_ACCOUNT"}
                            value={"MUST_CREATE_ACCOUNT"}
                        >
                            Accounts are required
                        </MenuItem>

                        <MenuItem
                            key={"ACCOUNT_OR_GUEST"}
                            value={"ACCOUNT_OR_GUEST"}
                        >
                            Accounts are optional
                        </MenuItem>

                        <MenuItem
                            key={"GUEST_ONLY"}
                            value={"GUEST_ONLY"}
                            disabled={offersPackagesOnly}
                        >
                            Accounts are disabled
                        </MenuItem>
                    </Select>
                </FormControl>
                <InfoTooltip
                    title={`"Accounts required" = force clients to create an account before booking\n
                        "Accounts optional" = clients can create an account if they wish or check out as guest – guests can still create an account after the fact and will have access to all their existing bookings made with that email address\n
                        "Accounts disabled" = force clients to check out as guest only (not compatible with packages)`}
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <FormControlLabel
                    control={
                        <Switch
                            name={"clientMayCreateAccount"}
                            checked={bookingStates.clientMayCreateAccount}
                            onChange={bookingStatesChangeHandler}
                            color="primary"
                            disabled={
                                bookingStates.checkoutOption === "GUEST_ONLY" ||
                                bookingStates.checkoutOption ===
                                    "ACCOUNT_OR_GUEST"
                            }
                        />
                    }
                    label="Clients can create accounts"
                />
                <InfoTooltip
                    title={
                        "If off, existing clients can log in, but new clients cannot create an account – client accounts can only be created from the admin console by an admin or a manager"
                    }
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <FormControl required fullWidth>
                    <TextField
                        variant="outlined"
                        id="clientNotesHeading"
                        label="Custom label for notes field"
                        size="small"
                        multiline
                        rows="3"
                        name={"clientNotesHeading"}
                        value={bookingStates.clientNotesHeading}
                        onChange={bookingStatesChangeHandler}
                    />
                </FormControl>
                <InfoTooltip
                    title={
                        "Instruct the client to enter any required information for their booking, e.g. name of participant, age, skill level, allergies, parking instructions for provider, etc."
                    }
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <FormControlLabel
                    control={
                        <Switch
                            name={"mandatoryNotes"}
                            checked={bookingStates.mandatoryNotes}
                            onChange={bookingStatesChangeHandler}
                            color="primary"
                        />
                    }
                    label="Notes field mandatory"
                />
                <InfoTooltip
                    title={
                        "Clients cannot make a booking without putting something in the notes field"
                    }
                />
            </Grid>
        </>
    );
}

export default CheckoutTab;
